<template>
	<div class="fill-height pointer-events-none">
		<div v-if="hasContent" :style="componentStyle">
			<component :is="iconSrc" v-if="hasIcon && iconLocal" />
			<div class="ply_button_icon" :style="iconStyle" v-else-if="hasIcon && !iconLocal"></div>
			<span class="ply_button_text" :style="textStyle" v-if="hasText">
				<template v-if="isPiggyback"><input type="checkbox" disabled />On send: </template> {{ textValue }}</span
			>
		</div>
		<div v-else-if="!hideNoDesignMessage" class="empty-button mt-2">No button designed yet</div>
		<!-- <ButtonRootContainer v-bind="bindData" /> -->
	</div>
</template>

<script>
// import ButtonRootContainer from './ButtonRootContainer';

export default {
	name: 'UiElementTreeBlockButton',
	components: {
		// ButtonRootContainer,
	},
	props: {
		uiElement: { type: Object },
		hideNoDesignMessage: { type: Boolean },
		placement: { type: Object },
	},
	computed: {
		isPiggyback() {
			return this.placement.is_piggyback;
		},
		injectionStyle() {
			return this.uiElement.metadata?.injectionStyle || {};
		},
		// bindData() {
		// 	return {
		// 		injectionStyle: this.uiElement.metadata.injectionStyle || {},
		// 		rootNode: this.uiElement.container_dom_json || {},
		// 	};
		// },
		iconSize() {
			if (this.hasIcon) {
				// const { size: iconSize } = this.icon;
				return 'cover';
			}
			return null;
		},
		iconLocal() {
			if (this.hasIcon) {
				const { local: localSrc } = this.icon;
				return localSrc;
			}
			return false;
		},
		iconSrc() {
			if (this.hasIcon) {
				const { name: iconName } = this.icon;
				if (this.iconLocal) {
					const iconComponent = require(`@/assets/icons/${iconName}.svg`);
					return iconComponent;
				} else {
					const splittedIconName = iconName.split('mdi-');
					let iconPropertyName;
					if (splittedIconName.length > 1) {
						[, iconPropertyName] = splittedIconName;
					} else {
						iconPropertyName = iconName;
					}
					return `https://cdn.jsdelivr.net/npm/@mdi/svg@5.9.55/svg/${iconPropertyName}.svg`;
				}
			}
			return null;
		},
		iconColor() {
			if (this.hasIcon) {
				const { fillColor: iconColor } = this.icon;
				return iconColor || 'black';
			}
			return null;
		},
		textFontSize() {
			if (this.hasText) {
				const { fontSize: textFontSize } = this.text;
				return `${textFontSize}px`;
			}
			return null;
		},
		textColor() {
			if (this.hasText) {
				const { color: textColor } = this.text;
				return textColor || 'black';
			}
			return null;
		},
		textValue() {
			if (this.hasText) {
				const { value: textValue } = this.text;
				return textValue || 'black';
			}
			return null;
		},
		hasIcon() {
			if (this.icon) {
				if (this.icon.name && this.icon.name !== 'ply-element-transparent') {
					return true;
				}
			}
			return false;
		},
		hasText() {
			if (this.text) {
				if (this.text.value) {
					return true;
				}
			}
			return false;
		},
		icon() {
			return this.injectionStyle.icon;
		},
		text() {
			return this.injectionStyle.text;
		},
		componentStyle() {
			let style = {};
			const { borderColor, backgroundColor, borderRadius /*, width*/ } = this.injectionStyle;
			style = {
				backgroundColor: backgroundColor || 'transparent',
				height: '100%',
				display: 'inline-flex',
				justifyContent: 'flex-start',
				alignItems: 'center',
				borderWidth: '1px',
				borderStyle: 'solid',
				borderColor: borderColor || 'transparent',
				borderRadius: `${borderRadius || 0}px`,
				// width: 'auto',
				maxWidth: '100%',
				overflow: 'hidden',
			};
			// if (width) {
			// 	// style['maxWidth'] = `${width}px`;
			// }
			return style;
		},
		iconStyle() {
			// should be identical to '.ply_button_icon' on PlyExt
			return {
				maskSize: this.iconSize,
				'-webkit-mask-size': this.iconSize,
				mask: `url('${this.iconSrc}') no-repeat 50% 50%`,
				'-webkit-mask': `url('${this.iconSrc}') no-repeat 50% 50%`,
				height: '100%',
				backgroundColor: this.iconColor,
				minWidth: '20px',
				minHeight: '25px',
				margin: '0 10px',
			};
		},
		textStyle() {
			// should be identical to '.ply_button_text' on PlyExt
			return {
				fontSize: this.textFontSize,
				color: this.textColor,
				maxWidth: '100%',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap',
				marginRight: '10px',
				display: 'flex',
				alignItems: 'center',
			};
		},
		hasContent() {
			const iconName = (this.icon || {}).name;
			return (this.texttext || {}).value || (iconName && iconName !== 'ply-element-default-icon');
		},
	},
};
</script>
<style scoped lang="scss">
.empty-button {
	size: 12px;
	color: #0000004c;
}

.ply_button_text > * {
	margin: 0 0.5rem;
}
</style>
